//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_OPCIONES_LISTA = "obtenerOpcionesLista";
export const OBTENER_OPCION_LISTA = "obtenerOpcionLista";
export const REGISTRAR_OPCION_LISTA = "registrarOpcionLista";
export const ACTUALIZAR_OPCION_LISTA = "actualizarOpcionLista";

// mutation types
export const SET_OPCIONES_LISTA = "setOpcionesListas";
export const SET_OPCION_LISTA = "setOpcionLista";

const state = {
    opcionesLista: [],
    opcionLista:[],
}

const getters = {
    obtenerOpcionesListas(state) {
      return state.asesores;
    },
}

const actions = {

    /**
     * Obtener las opciones (items) de la lista por id lista
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_OPCIONES_LISTA](context, datos) {

        /*
        * Si el estado es 0 va a traer a todos los items de la lista, de lo contrario va a traer los listas por estado
        *
        */
        let endpoint = `api/OpcionesLista/all/${datos.idLista}`
        if(datos.estadoI>0){
            endpoint = `api/OpcionesLista/Estado/${datos.estadoId}/${datos.idLista}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status===200){
                        context.commit(SET_OPCIONES_LISTA, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    async [OBTENER_OPCION_LISTA](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/OpcionesLista/`)
                .then(({ data }) => {
                    context.commit(SET_OPCION_LISTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },
    async [REGISTRAR_OPCION_LISTA](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/OpcionesLista`, datos)
                .then(({ data }) => {
                    context.commit(SET_OPCION_LISTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
    async [ACTUALIZAR_OPCION_LISTA](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/OpcionesLista/`, datos)
                .then(({ data }) => {
                    context.commit(SET_OPCION_LISTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }
  }

const mutations = {
    [SET_OPCIONES_LISTA](state, data) {
        state.opcionesLista = data;
    },

    [SET_OPCION_LISTA](state, data) {
        state.opcionLista = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}